import Vue from "vue";
import Vuex from "vuex";
import pkg from "package";
import * as actions from "./actions";
import * as getters from "./getters";
import app from "./modules/app";
import menu from "./modules/menu";
import user from "./modules/user";
import report from "./modules/stock_report";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

const store = new Vuex.Store({
  strict: false,
  actions,
  getters,
  modules: {
    app,
    menu,
    report,
    user
  },
  state: {
    pkg
  },
  mutations: {},
  plugins: [
    createPersistedState({
      paths: ["app", "user"]
    })
  ]
});

export default store;
